<template>
  <div class="feedback-page">
    <div class="feedback-list-wrap">
      <div class="feedback-list">
        <template v-for="item in feedbackList">
          <div class="feedback-wrap editor" :key="item.id" v-if="item.msg_type === 1">
            <div class="user_info">
              <img src="../../assets/imgs/logo.png" alt="" class="avatar" />
              <span class="name">{{ item.name }}</span>
              <span class="time">{{ item.created }}</span>
            </div>
            <div class="feedback-content-wrap">
              <div class="feedback-content">{{ item.content }}</div>
            </div>
          </div>
          <div class="feedback-wrap user" :key="item.id" v-else>
            <div class="user_info">
              <span class="time">{{ item.created }}</span>
              <span class="name">{{ item.name }}</span>
              <img class="avatar" :src="user.avatar" alt="" />
            </div>
            <div class="feedback-content-wrap">
              <div class="feedback-content">{{ item.content }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="textarea-wrap" :class="{ active: textareaFocus || feedback.length }">
      <el-input
        type="textarea"
        :rows="4"
        placeholder="在这里写下你的反馈与建议"
        v-model="feedback"
        @focus="textareaFocus = true"
        @blur="textareaFocus = false"
      >
      </el-input>
      <el-button type="text" :disabled="feedback.length === 0" @click="send">发送</el-button>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import requestApi from '@/service';

import { Input, Button } from 'element-ui';
import { mapState } from 'vuex';

export default {
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
  },
  data() {
    return {
      feedback: '',
      feedbackList: [],
      textareaFocus: false,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter(to, from, next) {
    if (!Cookies.get('token')) {
      window.$router.push('/login');
    } else {
      next();
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      requestApi('/api/v1/feedback/list/').then(({ details }) => {
        if (details) {
          this.feedbackList = details;
        }
      });
    },
    send() {
      if (this.feedback) {
        requestApi(
          '/api/v1/feedback/add/',
          {
            content: this.feedback,
          },
          'PUT'
        ).then(() => {
          this.$message.success('发送成功');
          this.feedback = '';
          this.getDataList();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-page {
  background: $C1;
  height: calc(100vh - 160px - 170px - 50px);
  padding-bottom: 170px;
}
.feedback-list-wrap {
  overflow-y: auto;
  height: 100%;
  padding: 30px;
  box-sizing: border-box;
}
.feedback-list {
  .feedback-wrap {
    margin-bottom: 40px;
    .user_info {
      display: flex;
      align-items: center;
      .avatar {
        display: block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      .name {
        font-size: 14px;
        line-height: 20px;
        color: #333;
      }
      .time {
        margin-left: 15px;
        font-size: 10px;
        color: #84849a;
      }
    }
    .feedback-content {
      font-size: 12px;
      color: $C3;
      text-align: justify;
      display: inline-block;
      width: auto;
    }
    &.editor {
      .user_info {
        .name {
          margin-left: 20px;
        }
        .time {
          margin-left: 15px;
        }
      }
      .feedback-content-wrap {
        text-align: left;
      }
      .feedback-content {
        padding-left: 50px;
      }
    }
    &.user {
      .user_info {
        justify-content: flex-end;
        .name {
          margin-right: 20px;
        }
        .time {
          margin-right: 15px;
        }
      }
      .feedback-content-wrap {
        text-align: right;
      }
      .feedback-content {
        padding-right: 50px;
      }
    }
  }
}
.textarea-wrap {
  height: 170px;
  background: $C10;
  position: relative;
  padding: 0 0 50px;
  box-sizing: border-box;
  width: 100%;
  border-top: 1px solid transparent;
  transition: background-color 0.3s ease-in, border-color 0.3s ease-in;
  &.active {
    border-color: #e0e0e0;
    background: $C1;
  }
  .el-textarea {
    box-sizing: border-box;
    width: 100%;
    background: transparent;
    height: 100%;
    ::v-deep.el-textarea__inner {
      padding: 20px 30px 5px;
      background-color: transparent;
      border: none;
      resize: none;
      max-height: 100%;
      height: 100%;
    }
  }
  .el-button {
    position: absolute;
    right: 30px;
    bottom: 20px;
    padding: 0;
    font-size: 18px;
    font-weight: bold;
    color: $C7;
    &.is-disabled {
      color: $C13;
    }
  }
}
</style>
